const userAgent = navigator.userAgent || navigator.vendor || window.opera;

export function detectMobileOS() {
  const isAndroid = /Android/.test(userAgent);
  const isiOS = /iPhone|iPad|iPod/.test(userAgent);
  const isHuawei =
    /Huawei/.test(userAgent) ||
    /EMUI/.test(userAgent) ||
    /HarmonyOS/.test(userAgent);

  let os = "Unknown OS";

  if (isAndroid) {
    os = "android";
  } else if (isiOS) {
    os = "ios";
  } else if (isHuawei) {
    os = "huawei";
  }

  return os;
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent
  );
}
